<div class="shareholder dashboard-approval-page">
    <div class="row">
        <div class="col-12 ml-auto mr-auto">
            <ng-container *ngIf="!loading">
                <!--    <app-back-button
                    *ngIf="applicableRole === 'ADM'"></app-back-button> -->
            </ng-container>

            <div class="text-right mb-2" *ngIf="loading && !signing">
                <ngx-skeleton-loader [theme]="{
                    width: '360px',
                    height: '25px',
                    margin:'0'
                  }">
                </ngx-skeleton-loader>
            </div>

            <!-- Alerta de adição de papel em andamento -->
            <div class="row mb-3" *ngIf="hasRoleDraft">
                <div class="col-12 d-flex justify-content-end">
                    <div class="role-draft-alert">
                        <div
                            class="d-flex align-items-center justify-content-between role-draft-alert__row">
                            <div
                                class="d-flex align-items-center role-draft-alert__content">
                                <svg-icon src="assets/images/icon-info.svg"
                                    fill="var(--warning)"
                                    class="role-draft-alert__icon"></svg-icon>
                                <span class="role-draft-alert__text">
                                    Existe uma adição de papel em andamento:
                                    <strong>{{ roleDraftInfo?.applicable_display
                                        || roleDraftInfo?.name || 'Papel'
                                        }}</strong>
                                </span>
                            </div>
                            <app-button (onClick)="continueRoleDraft()"
                                [center]="true" [outline]="true"
                                class="add-button"
                                style="min-width: auto; padding-left: 16px; font-size: 13px;">
                                Continuar adição de papel
                            </app-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="shareholder-card"
                [class.shareholder-card--actions-open]="showVersionsOptions">
                <div class="row w-100 no-gutters">
                    <div class="col-12 col-lg-8 d-flex flex-row"
                        *ngIf="loading && !signing">
                        <div class="shareholder-profile-initials bg-none">
                            <ngx-skeleton-loader appearance="circle" [theme]="{
                                width: '64px',
                                height: '64px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                        </div>
                        <app-spacer [right]="32"></app-spacer>
                        <div class="d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                height: '44px',
                                width: '500px',
                                margin:'0'
                              }">
                            </ngx-skeleton-loader>
                            <div class="d-flex flex-row align-items-center">
                                <ngx-skeleton-loader [theme]="{
                                height: '24px',
                                width:'150px'
                            }"></ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-8"
                        *ngIf="!loading && !loadingHeaderVersion && approval">
                        <div
                            class="d-flex flex-column w-100 shareholder-card-left">
                            <!-- Linha 1: Título -->
                            <span
                                class="shareholder-profile-name">{{getDisplayName(approval)}}</span>

                            <!-- Linha 2: Criado por ... em ... • Versão ... (Atual) -->
                            <div class="shareholder-card-line shareholder-card-line-2"
                                *ngIf="!isOnlyRepresentative && (approval.created_at || getVersionText(approval))">
                                <span class="shareholder-profile-type">
                                    <ng-container *ngIf="approval.created_at">
                                        Criado
                                        <ng-container
                                            *ngIf="approval.created_by_name">
                                            por
                                            {{approval.created_by_name}}
                                        </ng-container>
                                        em
                                        {{formatDate(approval.created_at)}}
                                    </ng-container>
                                    <ng-container
                                        *ngIf="approval.created_at && getVersionText(approval)">
                                        • </ng-container>
                                    <ng-container
                                        *ngIf="getVersionText(approval)">
                                        <span
                                            class="shareholder-version-with-badge">
                                            <span>{{getVersionText(approval)}}</span>
                                            <span
                                                [class]="getRegisterCadastroStatusBadgeClass()">
                                                {{
                                                getRegisterCadastroStatusLabel()
                                                }}
                                            </span>
                                        </span>
                                    </ng-container>
                                </span>
                            </div>

                            <!-- Linha 3: Por item: badge papel - badge status - badge estado -->
                            <div
                                class="d-flex flex-row align-items-center flex-wrap shareholder-card-line shareholder-card-line-3">
                                <ng-container *ngIf="!isOnlyRepresentative">
                                    <div class="role-control-badges-wrap">
                                        <ng-container
                                            *ngIf="roleControlsLoading">
                                            <span
                                                class="role-control-badge role-control-badge-skeleton"></span>
                                            <span
                                                class="role-control-badge role-control-badge-skeleton"></span>
                                            <span
                                                class="role-control-badge role-control-badge-skeleton"></span>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="!roleControlsLoading">
                                            <ng-container
                                                *ngFor="let rc of getRoleControlsForDisplay(approval); let last = last">
                                                <span
                                                    class="role-control-badge-group">
                                                    <span
                                                        class="role-control-badge role-control-badge-papel">
                                                        {{getRoleControlPapel(rc)}}
                                                    </span>
                                                    <ng-container
                                                        *ngIf="!isRepresentativeRoleControl(rc)">
                                                        <span
                                                            [class]="getRoleControlStatusBadgeClass(rc)">
                                                            {{getRoleControlStatusText(rc)}}
                                                        </span>
                                                        <span
                                                            [class]="getRoleControlEstadoBadgeClass(rc)">
                                                            {{getRoleControlEstadoText(rc)}}
                                                        </span>
                                                    </ng-container>
                                                </span>
                                                <span *ngIf="!last"
                                                    class="role-control-badge-group-divider"
                                                    aria-hidden="true"></span>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="isOnlyRepresentative">
                                    <span class="shareholder-profile-type">
                                        Representante
                                    </span>
                                </ng-container>
                            </div>

                            <!-- Alerta de versionamento em andamento - cores primárias do tema -->
                            <div *ngIf="!versioningIsComplete && versioningProgress"
                                class="versioning-progress-alert">
                                <div
                                    class="d-flex align-items-center justify-content-between versioning-progress-alert__row">
                                    <div
                                        class="d-flex align-items-center versioning-progress-alert__content">
                                        <svg-icon
                                            src="assets/images/icon-loading.svg"
                                            fill="var(--primary)"
                                            class="versioning-progress-alert__icon"></svg-icon>
                                        <span
                                            class="versioning-progress-alert__label">
                                            Gerando versionamento...
                                        </span>
                                    </div>
                                    <div
                                        class="d-flex align-items-center versioning-progress-alert__row">
                                        <span
                                            class="versioning-progress-alert__count">
                                            {{versioningProgress.completed}}/{{versioningProgress.total}}
                                        </span>
                                        <div
                                            class="versioning-progress-alert__track">
                                            <div class="versioning-progress-alert__bar"
                                                [style.width.%]="versioningProgress.percentage">
                                            </div>
                                        </div>
                                        <span
                                            class="versioning-progress-alert__percent">
                                            {{versioningProgress.percentage |
                                            number:'1.1-1'}}%
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Skeleton do header quando loadingHeaderVersion -->
                    <div class="col-12 col-lg-8"
                        *ngIf="!loading && loadingHeaderVersion && !signing">
                        <div class="d-flex flex-column w-100">
                            <!-- Skeleton do nome -->
                            <ngx-skeleton-loader [theme]="{
                                height: '28px',
                                width: '280px',
                                marginBottom: '12px',
                                borderRadius: '4px'
                            }"></ngx-skeleton-loader>
                            <!-- Skeleton da linha de informações -->
                            <div
                                class="d-flex flex-row align-items-center flex-wrap">
                                <!-- Skeleton do badge -->
                                <ngx-skeleton-loader [theme]="{
                                    height: '24px',
                                    width: '110px',
                                    borderRadius: '12px',
                                    marginRight: '8px'
                                }"></ngx-skeleton-loader>
                                <!-- Separador -->
                                <span class="shareholder-profile-type separator"
                                    style="opacity: 0.3;">•</span>
                                <!-- Skeleton: Cedente -->
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '70px',
                                    borderRadius: '4px',
                                    marginLeft: '8px',
                                    marginRight: '8px'
                                }"></ngx-skeleton-loader>
                                <!-- Separador -->
                                <span class="shareholder-profile-type separator"
                                    style="opacity: 0.3;">•</span>
                                <!-- Skeleton: Pessoa Física -->
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '100px',
                                    borderRadius: '4px',
                                    marginLeft: '8px',
                                    marginRight: '8px'
                                }"></ngx-skeleton-loader>
                                <!-- Separador -->
                                <span class="shareholder-profile-type separator"
                                    style="opacity: 0.3;">•</span>
                                <!-- Skeleton: Criado em -->
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '140px',
                                    borderRadius: '4px',
                                    marginLeft: '8px',
                                    marginRight: '8px'
                                }"></ngx-skeleton-loader>
                                <!-- Separador -->
                                <span class="shareholder-profile-type separator"
                                    style="opacity: 0.3;">•</span>
                                <!-- Skeleton: Versão -->
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '120px',
                                    borderRadius: '4px',
                                    marginLeft: '8px'
                                }"></ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-3" *ngIf="false">
                        <div class="d-flex flex-row align-items-center">
                            <svg-icon src="assets/images/icon-send.svg"
                                class="shareholder-profile-icon"></svg-icon>
                            <app-spacer [right]="16"></app-spacer>

                            <ng-container
                                *ngIf="approval.register.type === 'PF'">
                                <span
                                    class="shareholder-profile-contact">{{approval.register.person.email}}</span>
                            </ng-container>

                            <ng-container
                                *ngIf="approval.register.type !== 'PF'">
                                <span
                                    class="shareholder-profile-contact">{{approval.register.company?.contact_email}}</span>
                            </ng-container>
                        </div>

                        <app-spacer [bottom]="16"></app-spacer>

                        <div class="d-flex flex-row align-items-center">
                            <svg-icon src="assets/images/icon-phone.svg"
                                class="shareholder-profile-icon"></svg-icon>
                            <app-spacer [right]="16"></app-spacer>
                            <span
                                class="shareholder-profile-contact">{{formatPhone(getPhone(approval))}}</span>
                        </div>
                    </div>

                    <ng-container *ngIf="!loading && approval">
                        <ng-container *ngIf="!isSimplified">
                            <div class="col-12 col-lg-4 d-flex flex-column align-items-end shareholder-header-actions-col"
                                [class.shareholder-header-actions-col--dropdown-open]="showVersionsOptions"
                                [class.shareholder-header-actions-col--has-profile]="hasShareholderProfileInHeader()">
                                <div
                                    class="shareholder-header-actions-row d-flex justify-content-end w-100">
                                    <!-- <ng-container
                                        *ngIf="approval.can_sign && !approval.completed">
                                        <app-button
                                            (onClick)="handleApproval(true)">Aprovar</app-button>
                                        <app-spacer [right]="8"></app-spacer>
                                        <app-button [danger]="true"
                                            (onClick)="handleApproval(false,true)">Retornar</app-button>
                                        <app-spacer [right]="8"></app-spacer>
                                        <app-button [danger]="true"
                                            (onClick)="handleApproval(false)">Rejeitar</app-button>
                                    </ng-container> -->

                                    <!-- Botão de Versões - sempre visível -->
                                    <ng-container
                                        *ngIf="false && !isOnlyRepresentative && !isRepresentativeViewer">
                                        <!-- Botão quando estiver comparando ou visualizando -->
                                        <app-button
                                            *ngIf="comparingVersions || showVersionSelector"
                                            [danger]="true" [outline]="true"
                                            (onClick)="comparingVersions ? compareVersions() : viewAllVersions()"
                                            class="add-button">
                                            <svg-icon
                                                src="assets/images/icon-times.svg"
                                                class="filter-clear-icon"></svg-icon>
                                            <span
                                                *ngIf="comparingVersions">Parar
                                                de comparar versões</span>
                                            <span
                                                *ngIf="showVersionSelector && !comparingVersions">Parar
                                                de visualizar todas</span>
                                        </app-button>

                                        <!-- Dropdown quando não estiver ativo -->
                                        <div *ngIf="!comparingVersions && !showVersionSelector"
                                            class="dropdown-container versions-button"
                                            style="position: relative;"
                                            #toggleVersions>
                                            <button
                                                class="dropdown-container-content"
                                                [class.active]="showVersionsOptions"
                                                type="button"
                                                (click)="toggleVersionsOptions()">
                                                <span>Versões</span>
                                                <svg-icon
                                                    src="assets/images/icon-down.svg"></svg-icon>
                                            </button>

                                            <div class="dropdown"
                                                *ngIf="showVersionsOptions">
                                                <button class="dropdown-button"
                                                    (click)="compareVersions()">
                                                    Comparar versões
                                                </button>
                                                <button class="dropdown-button"
                                                    (click)="viewAllVersions()">
                                                    Visualizar todas
                                                </button>
                                            </div>
                                        </div>
                                        <app-spacer [right]="4"></app-spacer>
                                    </ng-container>

                                    <!-- Botão de Editar - escondido quando rejeitado (exceto para cedente, cotista ou prestador) -->
                                    <ng-container
                                        *ngIf="false && !shouldHideEditButton() && !isOnlyRepresentative && !isRepresentativeViewer">
                                        <!-- Dropdown de seleção de papel quando houver múltiplos papéis -->
                                        <ng-container
                                            *ngIf="hasMultipleRoles()">
                                            <ng-container
                                                *ngIf="getEditButtonTooltip(); else editRoleButtonWithoutTooltip">
                                                <app-tooltip
                                                    [text]="getEditButtonTooltip()"
                                                    [position]="'top'"
                                                    [zIndex]="1">
                                                    <app-button-with-dropdown
                                                        #editRoleButtonDropdown
                                                        label="Editar cadastro"
                                                        (toggleShowOptions)="toggleEditRoleDropdown()"
                                                        (onClick)="toggleEditRoleDropdown(); $event.stopPropagation()"
                                                        [showOptions]="showEditRoleDropdown"
                                                        [outline]="true"
                                                        [disabled]="isEditDisabled()">
                                                        <button type="button"
                                                            class="dropdown-button"
                                                            *ngFor="let role of getAvailableEditRoles()"
                                                            [disabled]="isEditRoleOptionDisabled(role)"
                                                            [attr.aria-disabled]="isEditRoleOptionDisabled(role)"
                                                            [attr.title]="isEditRoleOptionDisabled(role) ? 'Este papel está em aprovação e não pode ser editado' : null"
                                                            (click)="$event.stopPropagation(); !isEditRoleOptionDisabled(role) && selectEditRole(role)">
                                                            {{formatRoleName(role.applicable)}}
                                                        </button>
                                                    </app-button-with-dropdown>
                                                </app-tooltip>
                                            </ng-container>
                                            <ng-template
                                                #editRoleButtonWithoutTooltip>
                                                <app-button-with-dropdown
                                                    #editRoleButtonDropdownNoTooltip
                                                    label="Editar cadastro"
                                                    (toggleShowOptions)="toggleEditRoleDropdown()"
                                                    (onClick)="toggleEditRoleDropdown(); $event.stopPropagation()"
                                                    [showOptions]="showEditRoleDropdown"
                                                    [outline]="true"
                                                    [disabled]="isEditDisabled()">
                                                    <button type="button"
                                                        class="dropdown-button"
                                                        *ngFor="let role of getAvailableEditRoles()"
                                                        [disabled]="isEditRoleOptionDisabled(role)"
                                                        [attr.aria-disabled]="isEditRoleOptionDisabled(role)"
                                                        [attr.title]="isEditRoleOptionDisabled(role) ? 'Este papel está em aprovação e não pode ser editado' : null"
                                                        (click)="$event.stopPropagation(); !isEditRoleOptionDisabled(role) && selectEditRole(role)">
                                                        {{formatRoleName(role.applicable)}}
                                                    </button>
                                                </app-button-with-dropdown>
                                            </ng-template>
                                        </ng-container>

                                        <!-- Botão simples quando houver apenas um papel -->
                                        <ng-container
                                            *ngIf="!hasMultipleRoles()">
                                            <ng-container
                                                *ngIf="getEditButtonTooltip(); else buttonWithoutTooltip">
                                                <app-tooltip
                                                    [text]="getEditButtonTooltip()"
                                                    [position]="'top'"
                                                    [zIndex]="1">
                                                    <app-button
                                                        (onClick)="!isInApproval() && !isEditDisabled() && openEditWarningModal()"
                                                        [center]="true"
                                                        [outline]="true"
                                                        [disabled]="isEditDisabled()"
                                                        [loading]="editingLoading">
                                                        Editar cadastro
                                                    </app-button>
                                                </app-tooltip>
                                            </ng-container>
                                            <ng-template #buttonWithoutTooltip>
                                                <app-button
                                                    (onClick)="!isInApproval() && !isEditDisabled() && openEditWarningModal()"
                                                    [center]="true"
                                                    [outline]="true"
                                                    [disabled]="isEditDisabled()"
                                                    [loading]="editingLoading">
                                                    Editar cadastro
                                                </app-button>
                                            </ng-template>
                                        </ng-container>

                                        <app-spacer [right]="4"></app-spacer>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="isRepresentativeViewer && representativeSignRequired">
                                        <app-button
                                            (onClick)="!representativeHasSigned && handleRepresentativeSign()"
                                            [center]="true"
                                            [disabled]="representativeHasSigned || representativeSigning"
                                            [loading]="representativeSigning">
                                            {{ representativeHasSigned ?
                                            'Assinado' : 'Assinar' }}
                                        </app-button>
                                        <app-spacer [right]="4"></app-spacer>
                                    </ng-container>

                                    <!-- Botão de Aprovar - sempre visível se não estiver homologado -->
                                    <!-- Só aparece para master, owner ou usuário comum -->
                                    <!-- Não aparece quando o cadastro está rejeitado -->
                                    <ng-container
                                        *ngIf="!(approval?.completed && approval?.is_approved) && isMasterOrCommonUser() && !isRejected() && !isOnlyRepresentative && !isReadOnlyVersionView()">
                                        <ng-container
                                            *ngIf="isApproveDisabled(); else approveButtonWithoutTooltip">
                                            <app-tooltip
                                                [text]="getApproveButtonTooltip()"
                                                [position]="'top'">
                                                <app-button-with-dropdown
                                                    #approveButtonDropdown
                                                    label="Aprovar cadastro"
                                                    (toggleShowOptions)="toggleShowOptions()"
                                                    (onClick)="handleApproval(true); $event.stopPropagation()"
                                                    [showOptions]="showCtaOptions"
                                                    [disabled]="isApproveDisabled()">
                                                    <button
                                                        class="dropdown-button"
                                                        style="color:var(--danger)"
                                                        [disabled]="shouldAlwaysEnableApprovalButtons() ? false : !(approval.can_sign && !approval.completed)"
                                                        (click)="$event.stopPropagation(); handleApproval(false,true)"
                                                        *ngIf="(isMasterUser() && permissionObj.canReturn) || (isCommonUser() && isInApproval())">
                                                        Retornar
                                                    </button>
                                                    <button
                                                        class="dropdown-button"
                                                        style="color:var(--danger)"
                                                        [disabled]="shouldAlwaysEnableApprovalButtons() ? false : !(approval.can_sign && !approval.completed)"
                                                        (click)="$event.stopPropagation(); handleApproval(false)"
                                                        *ngIf="(isMasterUser() && permissionObj.canReject) || (isCommonUser() && isInApproval())">
                                                        Rejeitar
                                                    </button>
                                                    <button
                                                        class="dropdown-button"
                                                        [disabled]="shouldAlwaysEnableApprovalButtons() ? false : (approval.completed || !approval.can_sign)"
                                                        (click)="$event.stopPropagation(); handleApproval(true,false,true)"
                                                        *ngIf="isMasterUser() && permissionObj.canApprove">
                                                        Homologar
                                                    </button>
                                                </app-button-with-dropdown>
                                            </app-tooltip>
                                        </ng-container>
                                        <ng-template
                                            #approveButtonWithoutTooltip>
                                            <app-button-with-dropdown
                                                #approveButtonDropdownNoTooltip
                                                label="Aprovar cadastro"
                                                (toggleShowOptions)="toggleShowOptions()"
                                                (onClick)="handleApproval(true); $event.stopPropagation()"
                                                [showOptions]="showCtaOptions"
                                                [disabled]="isApproveDisabled()">
                                                <button class="dropdown-button"
                                                    style="color:var(--danger)"
                                                    [disabled]="shouldAlwaysEnableApprovalButtons() ? false : !(approval.can_sign && !approval.completed)"
                                                    (click)="$event.stopPropagation(); handleApproval(false,true)"
                                                    *ngIf="(isMasterUser() && permissionObj.canReturn) || (isCommonUser() && isInApproval())">
                                                    Retornar
                                                </button>
                                                <button class="dropdown-button"
                                                    style="color:var(--danger)"
                                                    [disabled]="shouldAlwaysEnableApprovalButtons() ? false : !(approval.can_sign && !approval.completed)"
                                                    (click)="$event.stopPropagation(); handleApproval(false)"
                                                    *ngIf="(isMasterUser() && permissionObj.canReject) || (isCommonUser() && isInApproval())">
                                                    Rejeitar
                                                </button>
                                                <button class="dropdown-button"
                                                    [disabled]="shouldAlwaysEnableApprovalButtons() ? false : (approval.completed || !approval.can_sign)"
                                                    (click)="$event.stopPropagation(); handleApproval(true,false,true)"
                                                    *ngIf="isMasterUser() && permissionObj.canApprove">
                                                    Homologar
                                                </button>
                                            </app-button-with-dropdown>
                                        </ng-template>

                                    </ng-container>

                                    <ng-container
                                        *ngIf="isMasterOrCommonUser() && !isRejected() && !isOnlyRepresentative">
                                        <app-spacer [right]="8"></app-spacer>
                                        <app-button
                                            *ngIf="isReadOnlyVersionView()"
                                            [danger]="true" [outline]="true"
                                            [center]="true"
                                            (onClick)="comparingVersions ? compareVersions() : viewAllVersions()">
                                            {{ comparingVersions ? 'Parar de
                                            comparar versões' : 'Parar de
                                            visualizar todas' }}
                                        </app-button>
                                        <app-button-with-dropdown
                                            *ngIf="!isReadOnlyVersionView()"
                                            #headerActionsDropdown
                                            class="header-actions-dropdown"
                                            label="Ações"
                                            (toggleShowOptions)="toggleVersionsOptions()"
                                            [showOptions]="showVersionsOptions"
                                            [outline]="true">
                                            <button class="dropdown-button"
                                                *ngIf="comparingVersions || showVersionSelector"
                                                (click)="comparingVersions ? compareVersions() : viewAllVersions()">
                                                {{ comparingVersions ? 'Parar de
                                                comparar versões' : 'Parar de
                                                visualizar todas' }}
                                            </button>
                                            <button class="dropdown-button"
                                                *ngIf="!comparingVersions && !showVersionSelector"
                                                (click)="compareVersions()">
                                                Comparar versões
                                            </button>
                                            <button class="dropdown-button"
                                                *ngIf="!comparingVersions && !showVersionSelector"
                                                (click)="viewAllVersions()">
                                                Visualizar todas
                                            </button>

                                            <button type="button"
                                                class="dropdown-button"
                                                *ngIf="!shouldHideEditButton()"
                                                [class.dropdown-button--disabled]="isEditDisabled()"
                                                [attr.title]="getEditButtonTooltip() || null"
                                                (click)="onEditFromActionsDropdownClick($event)">
                                                Editar cadastro
                                            </button>

                                            <button class="dropdown-button"
                                                *ngIf="canManageActivationStatus() && getRegisterUuidForRegistersApi() && !isCurrentRegisterEmAnalise()"
                                                (click)="openRegisterCadastroModalFromDropdown()">
                                                {{
                                                getRegisterCadastroDropdownLabel()
                                                }}
                                            </button>
                                            <button class="dropdown-button"
                                                *ngIf="canManageActivationStatus() && getEditableRoleControlsForPaperModal().length > 0"
                                                (click)="openPaperStatusModalFromDropdown()">
                                                Ativar/Inativar papel
                                            </button>
                                        </app-button-with-dropdown>
                                    </ng-container>
                                </div>

                                <div class="profile-info-container"
                                    [class.profile-info-container--passthrough]="showVersionsOptions"
                                    *ngIf="approval && approval.register && isShareholder() && registrationExpirationInfo">
                                    <div class="profile-badge"
                                        [style.background-color]="getCurrentProfile().badgeBackgroundColor"
                                        [style.color]="getCurrentProfile().badgeTextColor">
                                        {{getCurrentProfile().type}}
                                    </div>
                                    <span
                                        class="profile-expiration-text">{{getExpirationText()}}</span>
                                    <app-carbon-progress-bar
                                        *ngIf="!isNotDeclared() && !isExempt()"
                                        [value]="getProfileProgress()"
                                        [expired]="getCurrentProfile().expired"
                                        [width]="'200px'">
                                    </app-carbon-progress-bar>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="sign_view">
                            <div
                                class="col-12 col-lg-4 d-flex justify-content-end">
                                <app-button
                                    (onClick)="handleRepresentativeSign()">Assinar
                                    como representante</app-button>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="isSimplified">
                            <div
                                class="col-12 col-lg-4 d-flex justify-content-end">
                                <div class="custom-badge-black">
                                    Cadastro simplificado
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <app-spacer [bottom]="24"></app-spacer>

            <!-- Seletor de Versões - Movido para antes das etapas de aprovação -->
            <ng-container
                *ngIf="!loading && showVersionSelector && !comparingVersions && !isOnlyRepresentative">
                <div class="version-selector-wrapper-top">
                    <div class="version-selector-container">
                        <label class="version-selector-label">Versão</label>
                        <div class="dropdown-container comparing-versions-dropdown version-selector-dropdown"
                            #toggleVersionSelector>
                            <button
                                class="dropdown-container-content version-selector-button"
                                type="button"
                                [class.active]="showVersionDropdown"
                                (click)="toggleVersionDropdown()"
                                [disabled]="approvalService.isV3Loading()"
                                [attr.title]="null">
                                <span *ngIf="selectedVersion"
                                    class="version-selector-button-wrapper">
                                    <span class="version-text">
                                        Versão {{
                                        selectedVersion.version_number }}
                                        <span
                                            *ngIf="isCurrentVersion(selectedVersion)">(Atual)</span>
                                        <span
                                            *ngIf="selectedVersion.is_draft === true">(Rascunho)</span>
                                        - Criada em
                                        {{formatDateTime(selectedVersion.created_at)}}
                                        <span
                                            *ngIf="selectedVersion.valid_until">
                                            e válida até
                                            {{formatDateTime(selectedVersion.valid_until)}}
                                        </span>
                                    </span>
                                    <span class="version-status-badge"
                                        [ngClass]="getStatusBadgeClass(selectedVersion)">
                                        {{ getStatusLabel(selectedVersion)
                                        }}
                                    </span>
                                    <svg-icon
                                        src="assets/images/icon-down.svg"></svg-icon>
                                </span>
                                <span *ngIf="!selectedVersion"
                                    class="version-selector-button-wrapper">
                                    <span>Selecione a versão</span>
                                    <svg-icon
                                        src="assets/images/icon-down.svg"></svg-icon>
                                </span>
                            </button>
                            <div class="dropdown" *ngIf="showVersionDropdown">
                                <div *ngIf="loadingVersions"
                                    class="version-dropdown-loading">
                                    <svg-icon
                                        src="assets/images/icon-loading.svg"></svg-icon>
                                    <span>Aguarde...</span>
                                </div>
                                <div *ngIf="!loadingVersions">
                                    <div *ngFor="let item of allApprovals">
                                        <button *ngIf="item.revision"
                                            (click)="selectVersion(item)"
                                            class="version-dropdown-item">
                                            <span class="version-item-content">
                                                <span class="version-item-text">
                                                    Versão
                                                    {{item.version_number}}
                                                    <span
                                                        *ngIf="isCurrentVersion(item)">(Atual)</span>
                                                    <span
                                                        *ngIf="item.is_draft === true">(Rascunho)</span>
                                                    - Criada em
                                                    {{formatDateTime(item.created_at)}}
                                                    <span
                                                        *ngIf="item.valid_until">
                                                        e válida até
                                                        {{formatDateTime(item.valid_until)}}
                                                    </span>
                                                </span>
                                                <span
                                                    class="version-status-badge"
                                                    [ngClass]="getStatusBadgeClass(item)">
                                                    {{ getStatusLabel(item) }}
                                                </span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <app-spacer [bottom]="24"></app-spacer>
            </ng-container>

            <ng-container
                *ngIf="!signing && !isSimplified && approval && !isOnlyRepresentative && !loadingRepresentativeStep">
                <app-approvation-steps
                    [approval]="approval"></app-approvation-steps>
                <!-- <ng-container
                    *ngIf="approvalStepsTimeline && approvalStepsTimeline.length > 0; else noApprovalTimeline">
                    <app-approvation-timeline-steps
                        [timelineSteps]="approvalStepsTimeline"></app-approvation-timeline-steps>
                </ng-container> -->
                <ng-template #noApprovalTimeline>
                    <div class="approval-timeline-empty">
                        Usuário não possui fila de aprovação disponível.
                    </div>
                </ng-template>
            </ng-container>

            <ng-container *ngIf="!isOnlyRepresentative">
                <app-spacer [bottom]="60"></app-spacer>
            </ng-container>

            <ng-container *ngIf="loading && !signing">
                <div class="row">
                    <div class="col-2" *ngFor="let number of [0,1,2,3,4,5]">
                        <ngx-skeleton-loader [theme]="{
                height: '38px',
                margin:'0'
              }">
                        </ngx-skeleton-loader>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!loading || signing">
                <div class="d-flex">
                    <div class="dashboard-tabs-container">
                        <button type="button"
                            class="tab-scroll-button tab-scroll-left"
                            (click)="scrollTabs('left')"
                            [class.hidden]="!canScrollLeft"
                            [attr.aria-label]="'Rolar tabs para esquerda'">
                            <svg-icon
                                src="assets/images/icon-left.svg"></svg-icon>
                        </button>
                        <div class="dashboard-tabs-wrapper" #tabsWrapper
                            (scroll)="checkScrollButtons()">
                            <div class="dashboard-tabs" #tabsContainer>
                                <button *ngFor="let tab of tabs; let i = index"
                                    type="button" class="dashboard-tab"
                                    [class.active]="activedTab === tab.value"
                                    (click)="onChangeTab(i)">
                                    {{tab.label}}
                                </button>
                            </div>
                        </div>
                        <button type="button"
                            class="tab-scroll-button tab-scroll-right"
                            (click)="scrollTabs('right')"
                            [class.hidden]="!canScrollRight"
                            [attr.aria-label]="'Rolar tabs para direita'">
                            <svg-icon
                                src="assets/images/icon-right.svg"></svg-icon>
                        </button>
                    </div>
                </div>
            </ng-container>

            <app-spacer [bottom]="34"></app-spacer>

            <ng-container *ngIf="comparingVersions">
                <div class="row">
                    <div class="col-6">
                        <div class="version-selector-container">
                            <label class="version-selector-label">Versão
                                Principal</label>
                            <div class="dropdown-container comparing-versions-dropdown version-selector-dropdown"
                                #toggleLeftVersions>
                                <button
                                    class="dropdown-container-content version-selector-button"
                                    type="button"
                                    [class.active]="showLeftVersions"
                                    (click)="toggleLeftVersionsDropdown()"
                                    [attr.title]="null">
                                    <span *ngIf="selectedLeftVersion"
                                        class="version-selector-button-wrapper">
                                        <span class="version-text">
                                            Versão {{
                                            selectedLeftVersion.version_number
                                            }}
                                            <span
                                                *ngIf="isCurrentVersion(selectedLeftVersion)">(Atual)</span>
                                            <span
                                                *ngIf="selectedLeftVersion.is_draft === true">(Rascunho)</span>
                                            - Criada em
                                            {{formatDateTime(selectedLeftVersion.created_at)}}
                                            <span
                                                *ngIf="selectedLeftVersion.valid_until">
                                                e válida até
                                                {{formatDateTime(selectedLeftVersion.valid_until)}}
                                            </span>
                                        </span>
                                        <span class="version-status-badge"
                                            [ngClass]="getStatusBadgeClass(selectedLeftVersion)">
                                            {{
                                            getStatusLabel(selectedLeftVersion)
                                            }}
                                        </span>
                                        <svg-icon
                                            src="assets/images/icon-down.svg"></svg-icon>
                                    </span>
                                    <span *ngIf="!selectedLeftVersion"
                                        class="version-selector-button-wrapper">
                                        <span>Selecione a versão</span>
                                        <svg-icon
                                            src="assets/images/icon-down.svg"></svg-icon>
                                    </span>
                                </button>
                                <div class="dropdown" *ngIf="showLeftVersions">
                                    <div *ngIf="loadingLeftVersions"
                                        class="version-dropdown-loading">
                                        <svg-icon
                                            src="assets/images/icon-loading.svg"></svg-icon>
                                        <span>Aguarde...</span>
                                    </div>
                                    <div *ngIf="!loadingLeftVersions">
                                        <div *ngFor="let item of allApprovals">
                                            <button *ngIf="item.revision"
                                                (click)="selectLeftVersion(item)"
                                                class="version-dropdown-item">
                                                <span
                                                    class="version-item-content">
                                                    <span
                                                        class="version-item-text">
                                                        Versão
                                                        {{item.version_number}}
                                                        <span
                                                            *ngIf="isCurrentVersion(item)">(Atual)</span>
                                                        <span
                                                            *ngIf="item.is_draft === true">(Rascunho)</span>
                                                        - Criada em
                                                        {{formatDateTime(item.created_at)}}
                                                        <span
                                                            *ngIf="item.valid_until">
                                                            e válida até
                                                            {{formatDateTime(item.valid_until)}}
                                                        </span>
                                                    </span>
                                                    <span
                                                        class="version-status-badge"
                                                        [ngClass]="getStatusBadgeClass(item)">
                                                        {{ getStatusLabel(item)
                                                        }}
                                                    </span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="version-selector-container">
                            <label class="version-selector-label">Versão
                                Comparação</label>
                            <div class="dropdown-container comparing-versions-dropdown version-selector-dropdown"
                                #toggleRightVersions>
                                <button
                                    class="dropdown-container-content version-selector-button"
                                    type="button"
                                    [class.active]="showRightVersions"
                                    [disabled]="!selectedLeftVersion"
                                    (click)="toggleRightVersionsDropdown()"
                                    [attr.title]="null">
                                    <span *ngIf="selectedRightVersion"
                                        class="version-selector-button-wrapper">
                                        <span class="version-text">
                                            Versão {{
                                            selectedRightVersion.version_number
                                            }}
                                            <span
                                                *ngIf="isCurrentVersion(selectedRightVersion)">(Atual)</span>
                                            <span
                                                *ngIf="selectedRightVersion.is_draft === true">(Rascunho)</span>
                                            - Criada em
                                            {{formatDateTime(selectedRightVersion.created_at)}}
                                            <span
                                                *ngIf="selectedRightVersion.valid_until">
                                                e válida até
                                                {{formatDateTime(selectedRightVersion.valid_until)}}
                                            </span>
                                        </span>
                                        <span class="version-status-badge"
                                            [ngClass]="getStatusBadgeClass(selectedRightVersion)">
                                            {{
                                            getStatusLabel(selectedRightVersion)
                                            }}
                                        </span>
                                        <svg-icon
                                            src="assets/images/icon-down.svg"></svg-icon>
                                    </span>
                                    <span *ngIf="!selectedRightVersion"
                                        class="version-selector-button-wrapper">
                                        <span>{{selectedLeftVersion ? 'Selecione
                                            a versão' : 'Primeiro selecione uma
                                            versão principal'}}</span>
                                        <svg-icon
                                            src="assets/images/icon-down.svg"></svg-icon>
                                    </span>
                                </button>
                                <div class="dropdown" *ngIf="showRightVersions">
                                    <div *ngIf="loadingRightVersions"
                                        class="version-dropdown-loading">
                                        <svg-icon
                                            src="assets/images/icon-loading.svg"></svg-icon>
                                        <span>Aguarde...</span>
                                    </div>
                                    <div *ngIf="!loadingRightVersions">
                                        <div
                                            *ngFor="let item of getAvailableComparisonVersions()">
                                            <button *ngIf="item.revision"
                                                (click)="selectRightVersion(item)"
                                                class="version-dropdown-item">
                                                <span
                                                    class="version-item-content">
                                                    <span
                                                        class="version-item-text">
                                                        Versão
                                                        {{item.version_number}}
                                                        <span
                                                            *ngIf="isCurrentVersion(item)">(Atual)</span>
                                                        <span
                                                            *ngIf="item.is_draft === true">(Rascunho)</span>
                                                        - Criada em
                                                        {{formatDateTime(item.created_at)}}
                                                        <span
                                                            *ngIf="item.valid_until">
                                                            e válida até
                                                            {{formatDateTime(item.valid_until)}}
                                                        </span>
                                                    </span>
                                                    <span
                                                        class="version-status-badge"
                                                        [ngClass]="getStatusBadgeClass(item)">
                                                        {{ getStatusLabel(item)
                                                        }}
                                                    </span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <app-spacer [bottom]="24"></app-spacer>
            </ng-container>

            <div
                *ngIf="['complementary', 'address', 'bank'].includes(activedTab)">
                <app-dashboard-approval-complementary
                    [comparingVersions]="comparingVersions"
                    [activeTab]="activedTab"
                    [registrationExpirationInfo]="registrationExpirationInfo"
                    [isOnlyRepresentative]="isOnlyRepresentative"
                    [hasRepresentativeRole]="hasRepresentativeRole">
                </app-dashboard-approval-complementary>
            </div>

            <div *ngIf="activedTab === 'professional'">
                <app-dashboard-approval-professional
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-professional>
            </div>

            <div *ngIf="activedTab === 'representatives'">
                <app-dashboard-approval-representatives
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-representatives>
            </div>

            <div *ngIf="activedTab === 'powers'">
                <app-dashboard-approval-powers
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-powers>
            </div>

            <div *ngIf="activedTab === 'attachments'">
                <app-dashboard-approval-attachments (onClick)="getApproval()"
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-attachments>
            </div>

            <div *ngIf="activedTab === 'history'">
                <app-dashboard-approval-accompaniment
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-accompaniment>
            </div>

            <div *ngIf="activedTab === 'signs'">
                <app-dashboard-approval-signatures
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-signatures>
            </div>

            <div *ngIf="activedTab === 'funds'">
                <app-dashboard-approval-bonds
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-bonds>
            </div>

            <div *ngIf="activedTab === 'draft'">
                <app-dashboard-approval-draft
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-draft>
            </div>

            <div *ngIf="activedTab === 'composition'">
                <app-dashboard-approval-composition
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-composition>
            </div>


            <div *ngIf="activedTab === 'risk'">
                <app-dashboard-approval-risk
                    [comparingVersions]="comparingVersions" [isFund]="isFund">
                </app-dashboard-approval-risk>
            </div>

            <div *ngIf="activedTab === 'in_progress'">
                <ng-container *ngIf="!loading">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <h3>Detalhes/Versionamento sendo desenvolvidos
                                    nesse momento....</h3>
                                <app-spacer [bottom]="24"></app-spacer>
                                <p>Deixei apenas a aba documentos para poderem
                                    testar documentos compliance, o restante
                                    está sendo re-desenvolvido.</p>
                                <app-spacer [bottom]="16"></app-spacer>
                                <p><strong>Obs.:</strong> Essa mensagem está
                                    aqui apenas por que estamos em teste.</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div *ngIf="activedTab === 'documents'">
                <app-dashboard-approval-documents [approval]="approval"
                    [comparingVersions]="comparingVersions"></app-dashboard-approval-documents>
            </div>

            <div *ngIf="activedTab === 'internal-documents'">
                <app-dashboard-approval-internal-documents></app-dashboard-approval-internal-documents>
            </div>

            <!-- Outras abas comentadas -->
            <div *ngIf="activedTab === 'declarations'">
                <app-dashboard-approval-declarations
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-declarations>
            </div>


            <div *ngIf="activedTab === 'providers'">
                <app-dashboard-approval-providers
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-providers>
            </div>

            <div *ngIf="activedTab === 'income'">
                <app-dashboard-approval-income
                    [comparingVersions]="comparingVersions">
                </app-dashboard-approval-income>
            </div>


        </div>
    </div>

    <!-- Modal de warning movido para fora do ng-container com !loading para sempre estar disponível -->
    <app-warning-modal [active]="warningModal" (onClose)="closeWarningModal()">
        <h3>Atenção</h3>
        <app-spacer [bottom]="24"></app-spacer>

        <ng-container *ngIf="approve && !resetApproval && !homologated">
            <p>
                Você tem certeza que deseja aprovar o cadastro de
                <span class="person-name-highlight">
                    {{approval?.register?.type === 'PF' ?
                    approval?.register?.person?.full_name :
                    approval?.register?.company?.corporate_name}}
                </span>
            </p>
            <app-spacer [bottom]="56"></app-spacer>

            <app-button (onClick)="closeWarningModal()" [center]="true"
                [danger]="true" [disabled]="signing">
                Cancelar
            </app-button>
            <app-spacer [bottom]="8"></app-spacer>
            <app-button (onClick)="signApproval(approve, homologated)"
                [center]="true" class="add-button" [disabled]="signing">
                Sim, quero aprovar
            </app-button>
        </ng-container>

        <ng-container *ngIf="approve && !resetApproval && homologated">
            <form [formGroup]="homologateForm">
                <p>
                    Você tem certeza que deseja homologar o cadastro de
                    <span class="person-name-highlight">
                        {{approval?.register?.type === 'PF' ?
                        approval?.register?.person?.full_name :
                        approval?.register?.company?.corporate_name}}
                    </span>
                </p>
                <app-spacer [bottom]="16"></app-spacer>
                <app-input type="textarea" [group]="homologateForm"
                    controlName="reason" [rows]="4"
                    label="Esclareça o motivo da homologação" [noResize]="true">
                </app-input>
                <app-spacer [bottom]="56"></app-spacer>

                <app-button (onClick)="closeWarningModal()" [center]="true"
                    [disabled]="signing" class="add-button">
                    Cancelar
                </app-button>
                <app-spacer [bottom]="8"></app-spacer>
                <app-button (onClick)="signApproval(approve, homologated)"
                    [center]="true" class="add-button"
                    [disabled]="signing || homologateForm.invalid">
                    Sim, quero homologar
                </app-button>
            </form>
        </ng-container>

        <ng-container *ngIf="!approve && !resetApproval">
            <form [formGroup]="reproveForm">
                <p>
                    Você tem certeza que deseja reprovar o cadastro de
                    {{approval?.register?.type === 'PF' ?
                    approval?.register?.person?.full_name :
                    approval?.register?.company?.corporate_name}}
                </p>
                <app-spacer [bottom]="16"></app-spacer>
                <app-input type="textarea" [group]="reproveForm"
                    controlName="description" [rows]="4"
                    label="Esclareça o motivo da reprovação" [noResize]="true">
                </app-input>
                <app-spacer [bottom]="56"></app-spacer>

                <app-button (onClick)="closeWarningModal()" [center]="true"
                    [disabled]="signing" class="add-button">
                    Cancelar
                </app-button>
                <app-spacer [bottom]="8"></app-spacer>
                <app-button (onClick)="signApproval(approve)" [center]="true"
                    [disabled]="signing || this.reproveForm.invalid"
                    [danger]="true">
                    Sim, quero reprovar
                </app-button>
            </form>
        </ng-container>

        <ng-container *ngIf="resetApproval">
            <form [formGroup]="reproveForm">
                <p>
                    Você tem certeza que deseja retornar o cadastro de
                    {{approval?.register?.type === 'PF' ?
                    approval?.register?.person?.full_name :
                    approval?.register?.company?.corporate_name}}

                </p>
                <app-spacer [bottom]="16"></app-spacer>
                <app-input type="textarea" [group]="reproveForm"
                    controlName="description" [rows]="4"
                    label="Esclareça o motivo do retorno" [noResize]="true">
                </app-input>
                <app-spacer [bottom]="56"></app-spacer>

                <app-button (onClick)="closeWarningModal()" [center]="true"
                    [disabled]="signing" class="add-button">
                    Cancelar
                </app-button>
                <app-spacer [bottom]="8"></app-spacer>


                <app-button (onClick)="signApproval(approve)" [center]="true"
                    [disabled]="signing || this.reproveForm.invalid"
                    [danger]="true">
                    Sim, quero retornar
                </app-button>
            </form>
        </ng-container>

    </app-warning-modal>


    <!-- <app-warning-modal [active]="confirmEditModal"
        (onClose)="confirmEditModal = false">
        <h3>Atenção</h3>
        <app-spacer [bottom]="24"></app-spacer>

        <p>
            Este cadastro possui um rascunho em aprovação, deseja editar o
            rascunho?
        </p>
        <app-spacer [bottom]="56"></app-spacer>

        <app-button (onClick)="confirmEditModal = false" [center]="true"
            [danger]="true" [disabled]="signing">
            Cancelar
        </app-button>
        <app-spacer [bottom]="8"></app-spacer>
        <app-button (onClick)="redirectToEdit()" [center]="true"
            class="add-button" [loading]="signing">
            Sim, quero editar
        </app-button>
    </app-warning-modal> -->

    <!-- Carbon Warning Modal para validação de dados -->
    <app-carbon-warning-modal [active]="showValidationModal"
        [title]="getValidationModalTitle()"
        [message]="getValidationModalMessage()"
        [confirmText]="getValidationConfirmText()" [cancelText]="''"
        [confirmAction]="closeValidationModal.bind(this)"
        [cancelAction]="closeValidationModal.bind(this)"
        (onClose)="closeValidationModal()">
    </app-carbon-warning-modal>

    <!-- Carbon Warning Modal para aprovação de arquivo -->
    <app-carbon-warning-modal [active]="showFileApprovalModal"
        [title]="getFileApprovalModalTitle()"
        [message]="getFileApprovalModalMessage()"
        [confirmText]="getFileApprovalConfirmText()"
        [cancelText]="getFileApprovalCancelText()"
        [confirmAction]="confirmFileApproval.bind(this)"
        [cancelAction]="closeFileApprovalModal.bind(this)"
        (onClose)="closeFileApprovalModal()">
    </app-carbon-warning-modal>

    <!-- Carbon Warning Modal para rejeição de arquivo -->
    <app-carbon-warning-modal [active]="showFileRejectionModal"
        [title]="getFileRejectionModalTitle()"
        [message]="getFileRejectionModalMessage()"
        [confirmText]="getFileRejectionConfirmText()"
        [cancelText]="getFileRejectionCancelText()"
        [confirmAction]="confirmFileRejection.bind(this)"
        [cancelAction]="closeFileRejectionModal.bind(this)"
        (onClose)="closeFileRejectionModal()">
    </app-carbon-warning-modal>

    <!-- Carbon Warning Modal para confirmação de assinatura -->
    <app-carbon-warning-modal [active]="showRepresentativeSignModal"
        [title]="getRepresentativeSignModalTitle()"
        [message]="getRepresentativeSignModalMessage()"
        [confirmText]="getRepresentativeSignConfirmText()"
        [cancelText]="getRepresentativeSignCancelText()"
        [confirmAction]="confirmRepresentativeSign.bind(this)"
        [cancelAction]="closeRepresentativeSignModal.bind(this)"
        (onClose)="closeRepresentativeSignModal()">
    </app-carbon-warning-modal>

    <!-- Carbon Warning Modal para erro de assinatura -->
    <app-carbon-warning-modal [active]="showRepresentativeSignErrorModal"
        [title]="getRepresentativeSignErrorTitle()"
        [message]="getRepresentativeSignErrorMessage()"
        [confirmText]="getRepresentativeSignErrorConfirmText()"
        [cancelText]="''"
        [confirmAction]="closeRepresentativeSignErrorModal.bind(this)"
        [cancelAction]="closeRepresentativeSignErrorModal.bind(this)"
        (onClose)="closeRepresentativeSignErrorModal()">
    </app-carbon-warning-modal>

    <!-- Carbon Warning Modal para sucesso de aprovação de arquivo -->
    <app-carbon-warning-modal [active]="showFileApprovalSuccessModal"
        [title]="getFileApprovalSuccessTitle()"
        [message]="getFileApprovalSuccessMessage()"
        [confirmText]="getFileApprovalSuccessConfirmText()" [cancelText]="''"
        [confirmAction]="closeFileApprovalSuccessModal.bind(this)"
        [cancelAction]="closeFileApprovalSuccessModal.bind(this)"
        (onClose)="closeFileApprovalSuccessModal()">
    </app-carbon-warning-modal>

    <!-- Carbon Warning Modal para erro de aprovação de arquivo -->
    <app-carbon-warning-modal [active]="showFileApprovalErrorModal"
        [title]="getFileApprovalErrorTitle()"
        [message]="getFileApprovalErrorMessage()"
        [confirmText]="getFileApprovalErrorConfirmText()" [cancelText]="''"
        [confirmAction]="closeFileApprovalErrorModal.bind(this)"
        [cancelAction]="closeFileApprovalErrorModal.bind(this)"
        (onClose)="closeFileApprovalErrorModal()">
    </app-carbon-warning-modal>

    <!-- Carbon Warning Modal para aviso de edição de cadastro aprovado -->
    <app-carbon-warning-modal [active]="showEditWarningModal"
        [title]="getEditWarningModalTitle()" [customContent]="true"
        [contentOverflowVisible]="showEditRoleSelectInModal()"
        [confirmText]="getEditWarningConfirmText()"
        [cancelText]="getEditWarningCancelText()"
        [loading]="editingFullscreenLoading"
        [disableConfirm]="isEditWarningConfirmDisabled()"
        [confirmAction]="confirmEditRedirect.bind(this)"
        [cancelAction]="cancelEditWarningModal.bind(this)"
        (onClose)="cancelEditWarningModal()">
        <div class="edit-warning-modal">
            <p>{{ getEditWarningModalMessage() }}</p>
            <ng-container *ngIf="showEditRoleSelectInModal()">
                <app-spacer [bottom]="12"></app-spacer>
                <p class="edit-warning-modal-intro">
                    {{ getEditWarningRoleSelectIntro() }}
                </p>
                <app-spacer [bottom]="16"></app-spacer>
                <app-select [items]="editRoleSelectItems"
                    [group]="editWarningForm" controlName="roleId" label="Papel"
                    placeholder="Selecione o papel" appendTo="body">
                </app-select>
            </ng-container>
        </div>
    </app-carbon-warning-modal>

    <!-- Ativar/inativar cadastro (mesmo padrão que dashboard-user-list: overflow + multi-select) -->
    <app-carbon-warning-modal [active]="showRegisterCadastroModal"
        [title]="getRegisterCadastroModalTitle()" [customContent]="true"
        [contentOverflowVisible]="true" [skipAutoCloseOnConfirm]="true"
        [disableClose]="registerCadastroStatusSubmitting"
        [confirmText]="isCurrentRegisterActive() ? 'Confirmar inativação' : 'Confirmar ativação'"
        [cancelText]="'Cancelar'" [loading]="registerCadastroStatusSubmitting"
        [disableConfirm]="isRegisterActivationConfirmDisabledApproval()"
        [confirmAction]="confirmRegisterCadastroStatusChange.bind(this)"
        [cancelAction]="closeRegisterCadastroModal.bind(this)"
        (onClose)="closeRegisterCadastroModal()">
        <div class="paper-status-modal register-status-modal">
            <ng-container *ngIf="approval && isCurrentRegisterActive()">
                <p>
                    {{ getRegisterCadastroActionMessage() }}
                    <strong> {{ getDisplayName(approval) }}</strong>?
                </p>
                <app-spacer [top]="8"></app-spacer>
                <app-input [group]="registerActivatePapersForm"
                    controlName="reason" label="Motivo" [rows]="4"
                    placeholder="Descreva o motivo">
                </app-input>
            </ng-container>

            <ng-container *ngIf="approval && !isCurrentRegisterActive()">
                <ng-container *ngIf="isRegisterActivationSinglePaperApproval()">
                    <p>
                        O cadastro está inativo. Ao confirmar, o papel
                        <strong>{{
                            getSingleRegisterActivationPaperLabelApproval()
                            }}</strong> será ativo juntamente com o cadastro do
                        usuário
                        <strong>{{ getDisplayName(approval) }}</strong>. Deseja
                        continuar?
                    </p>
                </ng-container>

                <ng-container *ngIf="isRegisterActivationMultiPaperApproval()">
                    <p class="register-activate-intro">
                        Para ativar o cadastro, selecione o papel que deseja
                        reativar.
                    </p>
                    <div class="register-activate-select-wrap">
                        <app-select [items]="registerActivatePaperSelectItems"
                            [group]="registerActivatePapersForm"
                            controlName="paperId"
                            placeholder="Selecione o papel" label="Papel"
                            appendTo="body">
                        </app-select>
                    </div>
                </ng-container>
                <app-spacer [top]="8"></app-spacer>
                <app-input [group]="registerActivatePapersForm"
                    controlName="reason" label="Motivo" [rows]="4"
                    placeholder="Descreva o motivo">
                </app-input>
            </ng-container>
        </div>
    </app-carbon-warning-modal>

    <!-- Ativar/inativar papel (mesmo fluxo que dashboard-user-list) -->
    <app-carbon-warning-modal [active]="showPaperStatusModal"
        [title]="getPaperActionTitleApproval()" [customContent]="true"
        [contentOverflowVisible]="true" [skipAutoCloseOnConfirm]="true"
        [disableClose]="paperStatusSubmitting"
        [confirmText]="getEffectiveSelectedPaperRole() && isRoleControlActive(getEffectiveSelectedPaperRole()) ? 'Confirmar inativação' : 'Confirmar ativação'"
        [cancelText]="'Cancelar'"
        [disableConfirm]="(getEditableRoleControlsForPaperModal().length > 1 && !getEffectiveSelectedPaperRole()) || !paperStatusForm.valid"
        [loading]="paperStatusSubmitting"
        [confirmAction]="confirmPaperStatusChange.bind(this)"
        [cancelAction]="closePaperStatusModal.bind(this)"
        (onClose)="closePaperStatusModal()">
        <div class="paper-status-modal">
            <ng-container
                *ngIf="getEffectiveSelectedPaperRole(); else paperStatusSelectFirst">
                <p>
                    {{ getPaperActionMessageApproval() }}
                    <strong>{{ getRoleLabelForModalApproval() }}</strong> do
                    cadastro:
                </p>
                <p class="paper-status-modal-name">
                    <strong>{{ getDisplayNameForApproval() }}</strong>
                </p>
            </ng-container>
            <ng-template #paperStatusSelectFirst>
                <p>Selecione o papel que deseja ativar ou inativar.</p>
                <ng-container
                    *ngIf="getEditableRoleControlsForPaperModal().length > 1">
                    <app-spacer [bottom]="16"></app-spacer>
                    <app-select [items]="paperRoleSelectItemsCache"
                        [group]="paperStatusForm" controlName="role_control_id"
                        label="Papel" placeholder="Selecione o papel"
                        appendTo="body">
                    </app-select>
                </ng-container>
            </ng-template>
            <app-spacer [bottom]="16"></app-spacer>
            <app-spacer [top]="8"></app-spacer>
            <app-input [group]="paperStatusForm" controlName="reason"
                label="Motivo" [rows]="4" placeholder="Descreva o motivo">
            </app-input>
        </div>
    </app-carbon-warning-modal>

    <!-- Loading Spinner Fullscreen -->
    <app-loading-spinner [active]="signing"></app-loading-spinner>
    <app-loading-spinner
        [active]="loadingContinueRoleDraft"></app-loading-spinner>
    <app-loading-spinner
        [active]="loadingViewAllVersions"></app-loading-spinner>
    <app-loading-spinner
        [active]="editingFullscreenLoading"></app-loading-spinner>
    <app-loading-spinner
        [active]="paperStatusSubmitting || registerCadastroStatusSubmitting"
        customMessage="Processando ativação ou envio para aprovação...">
    </app-loading-spinner>
</div>